import React from "react";
import {
  Bar,
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

const CompetitorsTable = ({
  selectedStock,
  competitorData,
  handleStockSelect,
}) => {
  return (
    <div className="competitors-section">
      <h4>Competitive Landscape</h4>
      <div className="competitor-matrix">
        <table className="competitors-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>P/E Ratio</th>
              <th>ROIC</th>
              <th>Operating Margin</th>
              <th>Growth Rate</th>
              <th>Discount to Value</th>
            </tr>
          </thead>
          <tbody>
            {competitorData
              .filter(
                (comp) =>
                  comp.sector === selectedStock.sector &&
                  comp.symbol !== selectedStock.symbol
              )
              .slice(0, 5)
              .map((competitor) => {
                const discountPercent =
                  ((competitor.intrinsicValue - competitor.currentPrice) /
                    competitor.intrinsicValue) *
                  100;

                return (
                  <tr
                    key={competitor.symbol}
                    onClick={() => handleStockSelect(competitor)}
                    className="competitor-row"
                  >
                    <td className="competitor-info">
                      <div className="competitor-symbol">
                        {competitor.symbol}
                      </div>
                      <div className="competitor-name">{competitor.name}</div>
                    </td>
                    <td>{competitor.peRatio.toFixed(1)}</td>
                    <td>{competitor.roic.toFixed(1)}%</td>
                    <td>{competitor.operatingMargin.toFixed(1)}%</td>
                    <td>{competitor.growthRate.toFixed(1)}%</td>
                    <td className="discount">
                      <span
                        className={
                          discountPercent > 30
                            ? "high"
                            : discountPercent > 20
                            ? "medium"
                            : discountPercent <= 0
                            ? "negative"
                            : "low"
                        }
                      >
                        {discountPercent.toFixed(1)}%
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <div className="competitor-comparison">
        <h5>Performance Comparison</h5>
        <div className="chart-container">
          <ResponsiveContainer width="100%" height={300}>
            <Bar
              data={[
                {
                  name: "P/E Ratio",
                  [selectedStock.symbol]: selectedStock.peRatio,
                  "Sector Avg": selectedStock.peerPE,
                },
                {
                  name: "ROIC",
                  [selectedStock.symbol]: selectedStock.roic,
                  "Sector Avg": selectedStock.sectorROIC,
                },
                {
                  name: "Op. Margin",
                  [selectedStock.symbol]: selectedStock.operatingMargin,
                  "Sector Avg": selectedStock.sectorMargin,
                },
                {
                  name: "Growth",
                  [selectedStock.symbol]: selectedStock.growthRate,
                  "Sector Avg": selectedStock.sectorGrowth,
                },
              ]}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey={selectedStock.symbol} fill="#8884d8" />
              <Bar dataKey="Sector Avg" fill="#82ca9d" />
            </Bar>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default CompetitorsTable;
